// 取不到走兜底
export const SOURCEID =
  window._wltfChannel.urlParams.xeswx_sourceid ||
  window._wltfChannel.hotUrlParams.source ||
  window._wltfChannel.urlParams.sourceid ||
  window._wltfChannel.urlParams.sourceId ||
  '623334618'
